// extracted by mini-css-extract-plugin
export default {"advisors":"Advisors_advisors__YlxC5","advisorsImage":"Advisors_advisorsImage__opqTV","advisorsText":"Advisors_advisorsText__2S9Jt"};